import { DashboardActions } from 'actions';
import TextField from 'components/Course/TableOfContents/TextField';
import { GridCell, GridContainer } from 'components/Grid';
import * as Icons from 'components/Icons';
import CircularProgress from 'components/Material/CircularProgress';
import Cover from 'components/Material/Cover';
import * as Colors from 'components/Material/Styles/Colors';
import * as SvgIcons from 'components/Material/SvgIcons';
import { RadialSVGProgressBar } from 'components/Widgets';
import { Units } from 'Css';
import { Paper, Styles, LinearProgress } from 'material-ui';
import React, { Component, PropTypes } from 'react';
import { FormattedDate } from 'react-intl';
import Message from 'services/Message';
const { Spacing } = Styles;


const styles = {
  input: {
    fontSize: '20px'
  },
  progress: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    textAlign: 'center'
  }
};

const css = oxygenCss({
  root: {
    position: 'relative'
  },
  clickable: {
    cursor: 'pointer'
  },
  detail: {
    padding: `${Units.base * 2}px ${Units.base * 2}px ${
      Units.base
      }px ${Units.base * 2}px`,
    boxSizing: 'border-box'
  },
  progress: {
    textAlign: 'left',
    fontSize: 14,
    lineHeight: '32px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  },
  expires: {
    textAlign: 'right',
    fontSize: 14,
    lineHeight: '32px',
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  },
  byGroup: {
    fontSize: 14,
    lineHeight: '32px',
    display: 'inline-block',
    marginRight: 10,
    float: 'left'
  },
  itemWrapper: {
    padding: Units.base,
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 1,
    flexGrow: 0,
    width: 350,
    '@phone': {
      flexShrink: 0,
      flexGrow: 0,
      width: 350
    },
    '@tablet': {
      flexShrink: 0,
      flexGrow: 0,
      width: 350
    },
    '@desktop': {
      flexShrink: 0,
      flexGrow: 0,
      width: 370
    }
  },
  item: {},
  header: {
    fontSize: 20,
    lineHeight: '32px',
    margin: 0,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
});

export default class CourseDetails extends Component {
  static propTypes = {
    builder: PropTypes.bool
  };

  static defaultProps = {
    builder: true
  };

  static contextTypes = {
    router: PropTypes.object,
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  constructor() {
    super(...arguments);
    this.state = {
      progress: this.props.course.progress,
      uploadProgress: 0,
      activeCourse: null,
      coverImage: null
    };
  }

  onTouchTap = () => {
    if (this.props.onNavigate) {
      this.props.onNavigate();
    }
  };

  save() {
    const { course } = this.props;
    if (this.refs.name.getValue().trim().length != 0) {
      if (this.refs.name.getValue().length > 50) {
        return Message.info(this.context.getIntlMessage('course.nameTooLong'));
      }
    } else {
      return Message.info(this.context.getIntlMessage('course.nameNotEmpty'));
    }

    if (this.state.coverImage) {
      DashboardActions.saveCourse({
        id: course.id,
        name: this.refs.name.getValue(),
        coverImage: { id: this.state.coverImage.id }
      });
    } else {
      DashboardActions.saveCourse({
        id: course.id,
        name: this.refs.name.getValue()
      });
    }
  }

  onDuplicate() {
    let { course } = this.props;
    DashboardActions.duplicateCourse(course);
  }

  delete() {
    this.props.onDeleteComponent(this.props.course);
  }

  handleFile(e) {
    this.setState({ uploadProgress: 0, progressing: true });
    SteelCompass.upload(e.target.files, {
      progress: event => {
        this.setState({ uploadProgress: event.percentage });
      },
      success: response => {
        this.setState({ progressing: false, uploadProgress: 0 });
        let file = response.data && response.data[0] && response.data[0].file;
        this.setState({ coverImage: file });
      }
    });
  }

  renderEditMode() {
    let course = this.props.course,
      progress = this.state.progress,
      coverImage = this.state.coverImage || course.coverImage,
      uploadProgress;

    if (this.state.uploadProgress > 0 && this.state.uploadProgress < 100) {
      uploadProgress = (
        <div className="course-progress">
          <CircularProgress
            size={2}
            progress={this.state.uploadProgress * 100}
            progressWidth={2}
            trackWidth={2}
            cornersWidth={1}
          />
        </div>
      );
    }

    return (
      <div>
        <Cover
          image={coverImage.id && coverImage.url}
          defaultIcon="FileCloudUpload"
        >
          <input
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              opacity: 0
            }}
            type="file"
            onChange={this.handleFile.bind(this)}
            multiple={false}
            accept={'image/*'}
          />
        </Cover>
        {uploadProgress}
        <div className={css.detail}>
          <TextField
            inputStyle={styles.input}
            onEnterKeyDown={this.save.bind(this)}
            fullWidth={true}
            hintText={this.context.getIntlMessage('course.new')}
            type="text"
            ref="name"
            defaultValue={course.name}
          />
          {<div className={css.progress}>{course.ownerName}</div>}
        </div>
      </div>
    );
  }

  getProgressStyle(progressSize) {
    let coverHeight = Spacing.desktopKeylineIncrement * 4;
    return Object.assign({}, styles.progress, {
      padding: (coverHeight - progressSize - 2 * Spacing.desktopGutterMore) / 2
    });
  }

  renderDetailMode() {
    let course = this.props.course,
      progress = this.state.progress,
      coverImage = course.coverImage,
      progressSize = 2;
    const { editor } = this.props;
    const themeColor = Colors.Colors.coursio[500].material;
    let progressElement;

    if (!editor) {
      if (progress === 1) {
        progressElement = <Icons.ChapterDone color={themeColor} />;
      } else {
        progressElement = (
          <LinearProgress mode="determinate" value={progress * 100} />
        );
      }
    }

    let expires;
    let expireColor = Colors.Colors.grey[500].material;
    const expiryDate = new Date(course.expires);
    if (
      Object.prototype.toString.call(expiryDate) === '[object Date]' &&
      !isNaN(expiryDate.getTime())
    ) {
      const now = Date.now();
      if (expiryDate - now < 24 * 60 * 60 * 30 * 1000) {
        expireColor = Colors.Colors.orange[500].material;
      } else if (expiryDate - now < 0) {
        expireColor = Colors.Colors.red[500].material;
      }
      expires = <FormattedDate value={expiryDate} />;
    } else {
      expires = course.expires;
    }
    const expireIcon = (
      <SvgIcons.ActionSchedule
        style={{ verticalAlign: 'middle', width: 18, height: 18 }}
        color={expireColor}
      />
    );

    return (
      <div className={css.clickable} onTouchTap={this.onTouchTap}>
        <Cover
          backgroundColor={
            (!editor && this.context.muiTheme.rawTheme.palette.primary1Color) ||
            'rgba(0, 0, 0, 0.5)'
          }
          image={coverImage.id && coverImage.url}
          noImage={!editor}
        />
        <div className={css.detail}>
          <div className={css.header}>{course.name}</div>
          <GridContainer fluid>
            {!editor && (
              <GridCell size={12}>
                <div className={css.progress}>
                  {progressElement}
                  {course.ownerName}
                </div>
              </GridCell>
            )}
            <GridCell size={12}>
              <div className={css.expires} style={{ color: expireColor }}>
                {course.ucpType === 8 && <p className={css.byGroup}>managed by group</p>}
                {expireIcon}
                {expires}
              </div>
            </GridCell>
          </GridContainer>
        </div>
      </div>
    );
  }

  render() {
    let { course, className, mode, ...other } = this.props,
      content
    const { editor } = this.props;
    if (mode === 'edit' && editor) {
      content = this.renderEditMode();
    } else {
      content = this.renderDetailMode();
    }
    return (
      <div className={css.itemWrapper}>
        <Paper {...other} className={css.item}>
          {content}
          {this.props.children}
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/CourseDetails.js